import { useState, useEffect, useCallback } from 'react';
import { dataPath } from '../services/dataService';

const TTL_MS = 5 * 60 * 1000; // 5 minutes

// { url → { data, ts } }
const cache = {};

async function fetchJson(url) {
  const cached = cache[url];
  if (cached && Date.now() - cached.ts < TTL_MS) return cached.data;
  const res = await fetch(url);
  if (!res.ok) throw new Error(`${res.status} loading ${url}`);
  const data = await res.json();
  cache[url] = { data, ts: Date.now() };
  return data;
}

export function useSportsData() {
  const [index, setIndex] = useState(null);   // { categories, guruTipIcons }
  const [loading, setLoading] = useState(true);
  const [error, setError]   = useState(null);

  useEffect(() => {
    fetchJson(dataPath('sportsIndex'))
      .then(setIndex)
      .catch(setError)
      .finally(() => setLoading(false));
  }, []);

  // Fetch a single sport or parent (with subcategories) by id
  const fetchCategory = useCallback(async (id) => {
    return fetchJson(dataPath('sportCategory', { id }));
  }, []);

  return { index, loading, error, fetchCategory };
}

export function useLanguages() {
  const [languages, setLanguages] = useState([]);
  useEffect(() => {
    fetchJson(dataPath('languages'))
      .then(d => setLanguages(d.available))
      .catch(() => {});
  }, []);
  return languages;
}
